// These are the days associated with a number for the CSS Grid columns.
export const calDays = {
  M: 1,
  T: 2,
  W: 3,
  R: 4,
  F: 5,
  Sa: 6,
};

// These are the times associated with the number for the CSS Grid rows.
export const calTimes = {
  '6am': 1,
  '6:05am': 2,
  '6:10am': 3,
  '6:15am': 4,
  '6:20am': 5,
  '6:25am': 6,
  '6:30am': 7,
  '6:35am': 8,
  '6:40am': 9,
  '6:45am': 10,
  '6:50am': 11,
  '6:55am': 12,
  '7am': 13,
  '7:05am': 14,
  '7:10am': 15,
  '7:15am': 16,
  '7:20am': 17,
  '7:25am': 18,
  '7:30am': 19,
  '7:35am': 20,
  '7:40am': 21,
  '7:45am': 22,
  '7:50am': 23,
  '7:55am': 24,
  '8am': 25,
  '8:05am': 26,
  '8:10am': 27,
  '8:15am': 28,
  '8:20am': 29,
  '8:25am': 30,
  '8:30am': 31,
  '8:35am': 32,
  '8:40am': 33,
  '8:45am': 34,
  '8:50am': 35,
  '8:55am': 36,
  '9am': 37,
  '9:05am': 38,
  '9:10am': 39,
  '9:15am': 40,
  '9:20am': 41,
  '9:25am': 42,
  '9:30am': 43,
  '9:35am': 44,
  '9:40am': 45,
  '9:45am': 46,
  '9:50am': 47,
  '9:55am': 48,
  '10am': 49,
  '10:05am': 50,
  '10:10am': 51,
  '10:15am': 52,
  '10:20am': 53,
  '10:25am': 54,
  '10:30am': 55,
  '10:35am': 56,
  '10:40am': 57,
  '10:45am': 58,
  '10:50am': 59,
  '10:55am': 60,
  '11am': 61,
  '11:05am': 62,
  '11:10am': 63,
  '11:15am': 64,
  '11:20am': 65,
  '11:25am': 66,
  '11:30am': 67,
  '11:35am': 68,
  '11:40am': 69,
  '11:45am': 70,
  '11:50am': 71,
  '11:55am': 72,
  '12pm': 73,
  '12:05pm': 74,
  '12:10pm': 75,
  '12:15pm': 76,
  '12:20pm': 77,
  '12:25pm': 78,
  '12:30pm': 79,
  '12:35pm': 80,
  '12:40pm': 81,
  '12:45pm': 82,
  '12:50pm': 83,
  '12:55pm': 84,
  '1pm': 85,
  '1:05pm': 86,
  '1:10pm': 87,
  '1:15pm': 88,
  '1:20pm': 89,
  '1:25pm': 90,
  '1:30pm': 91,
  '1:35pm': 92,
  '1:40pm': 93,
  '1:45pm': 94,
  '1:50pm': 95,
  '1:55pm': 96,
  '2pm': 97,
  '2:05pm': 98,
  '2:10pm': 99,
  '2:15pm': 100,
  '2:20pm': 101,
  '2:25pm': 102,
  '2:30pm': 103,
  '2:35pm': 104,
  '2:40pm': 105,
  '2:45pm': 106,
  '2:50pm': 107,
  '2:55pm': 108,
  '3pm': 109,
  '3:05pm': 110,
  '3:10pm': 111,
  '3:15pm': 112,
  '3:20pm': 113,
  '3:25pm': 114,
  '3:30pm': 115,
  '3:35pm': 116,
  '3:40pm': 117,
  '3:45pm': 118,
  '3:50pm': 119,
  '3:55pm': 120,
  '4pm': 121,
  '4:05pm': 122,
  '4:10pm': 123,
  '4:15pm': 124,
  '4:20pm': 125,
  '4:25pm': 126,
  '4:30pm': 127,
  '4:35pm': 128,
  '4:40pm': 129,
  '4:45pm': 130,
  '4:50pm': 131,
  '4:55pm': 132,
  '5pm': 133,
  '5:05pm': 134,
  '5:10pm': 135,
  '5:15pm': 136,
  '5:20pm': 137,
  '5:25pm': 138,
  '5:30pm': 139,
  '5:35pm': 140,
  '5:40pm': 141,
  '5:45pm': 142,
  '5:50pm': 143,
  '5:55pm': 144,
  '6pm': 145,
  '6:05pm': 146,
  '6:10pm': 147,
  '6:15pm': 148,
  '6:20pm': 149,
  '6:25pm': 150,
  '6:30pm': 151,
  '6:35pm': 152,
  '6:40pm': 153,
  '6:45pm': 154,
  '6:50pm': 155,
  '6:55pm': 156,
  '7pm': 157,
  '7:05pm': 158,
  '7:10pm': 159,
  '7:15pm': 160,
  '7:20pm': 161,
  '7:25pm': 162,
  '7:30pm': 163,
  '7:35pm': 164,
  '7:40pm': 165,
  '7:45pm': 166,
  '7:50pm': 167,
  '7:55pm': 168,
  '8pm': 169,
  '8:05pm': 170,
  '8:10pm': 171,
  '8:15pm': 172,
  '8:20pm': 173,
  '8:25pm': 174,
  '8:30pm': 175,
  '8:35pm': 176,
  '8:40pm': 177,
  '8:45pm': 178,
  '8:50pm': 179,
  '8:55pm': 180,
  '9pm': 181,
  '9:05pm': 182,
  '9:10pm': 183,
  '9:15pm': 184,
  '9:20pm': 185,
  '9:25pm': 186,
  '9:30pm': 187,
  '9:35pm': 188,
  '9:40pm': 189,
  '9:45pm': 190,
  '9:50pm': 191,
  '9:55pm': 192,
  '10pm': 193,
  '10:05pm': 194,
  '10:10pm': 195,
  '10:15pm': 196,
  '10:20pm': 197,
  '10:25pm': 198,
  '10:30pm': 199,
  '10:35pm': 200,
  '10:40pm': 201,
  '10:45pm': 202,
  '10:50pm': 203,
  '10:55pm': 204,
};

export const colors = {
  0: '#bdbbc9',
  1: '#ffb500',
  2: '#4da977',
  3: '#4DB5D9',
  4: '#78BE20',
  5: '#C5E86C',
  6: '#00BFB3',
  7: '#E18E4D',
  8: '#F3BAAC',
  9: '#D1E2EE',
  10: '#4DD2CA',
  11: '#81be79',
  12: '#99D5E9',
  13: '#BDBBC9',
  14: '#DDD0CE',
  15: '#D0A8A1',
  16: '#81BE79',
  17: '#FFB500',
  18: '#aad9d0',
  19: '#FBD865',
  20: '#8b87a1',
  21: '#A7A8AA',
  22: '#FDEFC1',
  23: '#99CEB1',
  24: '#00688c',
  25: '#EEBE99',
  26: '#EEEEF2',
  27: '#99E5E1',
  28: '#fce493',
  29: '#C9E5A6',
  30: '#E6F3EC',
  31: '#F9FDF0',
  32: '#4DB5D9',
  33: '#78BE20',
  34: '#A1D263',
  35: '#86C8BC',
  36: '#C5E86C',
  37: '#BDBBC9',
  38: '#DDD0CE',
  39: '#E18E4D',
  40: '#4DD2CA',
  41: '#FFB500',
  42: '#99e5e1',
  43: '#D0A8A1',
  44: '#4DA977',
  45: '#EEBE99',
  46: '#FDEFC1',
  47: '#00BFB3',
  48: '#DCDCDD',
  49: '#E4CDC9',
  50: '#FFE199',
};

export const selectDays = [
  { value: 'M', label: 'M' },
  { value: 'T', label: 'T' },
  { value: 'W', label: 'W' },
  { value: 'R', label: 'R' },
  { value: 'F', label: 'F' },
  { value: 'Sa', label: 'Sa' },
  { value: 'MW', label: 'MW' },
  { value: 'MWF', label: 'MWF' },
  { value: 'TR', label: 'TR' },
];

export const selectTimes = [
  { value: '6am', label: '6am' },
  { value: '6:05am', label: '6:05am' },
  { value: '6:10am', label: '6:10am' },
  { value: '6:15am', label: '6:15am' },
  { value: '6:20am', label: '6:20am' },
  { value: '6:25am', label: '6:25am' },
  { value: '6:30am', label: '6:30am' },
  { value: '6:35am', label: '6:35am' },
  { value: '6:40am', label: '6:40am' },
  { value: '6:45am', label: '6:45am' },
  { value: '6:50am', label: '6:50am' },
  { value: '6:55am', label: '6:55am' },
  { value: '7am', label: '7am' },
  { value: '7:05am', label: '7:05am' },
  { value: '7:10am', label: '7:10am' },
  { value: '7:15am', label: '7:15am' },
  { value: '7:20am', label: '7:20am' },
  { value: '7:25am', label: '7:25am' },
  { value: '7:30am', label: '7:30am' },
  { value: '7:35am', label: '7:35am' },
  { value: '7:40am', label: '7:40am' },
  { value: '7:45am', label: '7:45am' },
  { value: '7:50am', label: '7:50am' },
  { value: '7:55am', label: '7:55am' },
  { value: '8am', label: '8am' },
  { value: '8:05am', label: '8:05am' },
  { value: '8:10am', label: '8:10am' },
  { value: '8:15am', label: '8:15am' },
  { value: '8:20am', label: '8:20am' },
  { value: '8:25am', label: '8:25am' },
  { value: '8:30am', label: '8:30am' },
  { value: '8:35am', label: '8:35am' },
  { value: '8:40am', label: '8:40am' },
  { value: '8:45am', label: '8:45am' },
  { value: '8:50am', label: '8:50am' },
  { value: '8:55am', label: '8:55am' },
  { value: '9am', label: '9am' },
  { value: '9:05am', label: '9:05am' },
  { value: '9:10am', label: '9:10am' },
  { value: '9:15am', label: '9:15am' },
  { value: '9:20am', label: '9:20am' },
  { value: '9:25am', label: '9:25am' },
  { value: '9:30am', label: '9:30am' },
  { value: '9:35am', label: '9:35am' },
  { value: '9:40am', label: '9:40am' },
  { value: '9:45am', label: '9:45am' },
  { value: '9:50am', label: '9:50am' },
  { value: '9:55am', label: '9:55am' },
  { value: '10am', label: '10am' },
  { value: '10:05am', label: '10:05am' },
  { value: '10:10am', label: '10:10am' },
  { value: '10:15am', label: '10:15am' },
  { value: '10:20am', label: '10:20am' },
  { value: '10:25am', label: '10:25am' },
  { value: '10:30am', label: '10:30am' },
  { value: '10:35am', label: '10:35am' },
  { value: '10:40am', label: '10:40am' },
  { value: '10:45am', label: '10:45am' },
  { value: '10:50am', label: '10:50am' },
  { value: '10:55am', label: '10:55am' },
  { value: '11am', label: '11am' },
  { value: '11:05am', label: '11:05am' },
  { value: '11:10am', label: '11:10am' },
  { value: '11:15am', label: '11:15am' },
  { value: '11:20am', label: '11:20am' },
  { value: '11:25am', label: '11:25am' },
  { value: '11:30am', label: '11:30am' },
  { value: '11:35am', label: '11:35am' },
  { value: '11:40am', label: '11:40am' },
  { value: '11:45am', label: '11:45am' },
  { value: '11:50am', label: '11:50am' },
  { value: '11:55am', label: '11:55am' },
  { value: '12pm', label: '12pm' },
  { value: '12:05pm', label: '12:05pm' },
  { value: '12:10pm', label: '12:10pm' },
  { value: '12:15pm', label: '12:15pm' },
  { value: '12:20pm', label: '12:20pm' },
  { value: '12:25pm', label: '12:25pm' },
  { value: '12:30pm', label: '12:30pm' },
  { value: '12:35pm', label: '12:35pm' },
  { value: '12:40pm', label: '12:40pm' },
  { value: '12:45pm', label: '12:45pm' },
  { value: '12:50pm', label: '12:50pm' },
  { value: '12:55pm', label: '12:55pm' },
  { value: '1pm', label: '1pm' },
  { value: '1:05pm', label: '1:05pm' },
  { value: '1:10pm', label: '1:10pm' },
  { value: '1:15pm', label: '1:15pm' },
  { value: '1:20pm', label: '1:20pm' },
  { value: '1:25pm', label: '1:25pm' },
  { value: '1:30pm', label: '1:30pm' },
  { value: '1:35pm', label: '1:35pm' },
  { value: '1:40pm', label: '1:40pm' },
  { value: '1:45pm', label: '1:45pm' },
  { value: '1:50pm', label: '1:50pm' },
  { value: '1:55pm', label: '1:55pm' },
  { value: '2pm', label: '2pm' },
  { value: '2:05pm', label: '2:05pm' },
  { value: '2:10pm', label: '2:10pm' },
  { value: '2:15pm', label: '2:15pm' },
  { value: '2:20pm', label: '2:20pm' },
  { value: '2:25pm', label: '2:25pm' },
  { value: '2:30pm', label: '2:30pm' },
  { value: '2:35pm', label: '2:35pm' },
  { value: '2:40pm', label: '2:40pm' },
  { value: '2:45pm', label: '2:45pm' },
  { value: '2:50pm', label: '2:50pm' },
  { value: '2:55pm', label: '2:55pm' },
  { value: '3pm', label: '3pm' },
  { value: '3:05pm', label: '3:05pm' },
  { value: '3:10pm', label: '3:10pm' },
  { value: '3:15pm', label: '3:15pm' },
  { value: '3:20pm', label: '3:20pm' },
  { value: '3:25pm', label: '3:25pm' },
  { value: '3:30pm', label: '3:30pm' },
  { value: '3:35pm', label: '3:35pm' },
  { value: '3:40pm', label: '3:40pm' },
  { value: '3:45pm', label: '3:45pm' },
  { value: '3:50pm', label: '3:50pm' },
  { value: '3:55pm', label: '3:55pm' },
  { value: '4pm', label: '4pm' },
  { value: '4:05pm', label: '4:05pm' },
  { value: '4:10pm', label: '4:10pm' },
  { value: '4:15pm', label: '4:15pm' },
  { value: '4:20pm', label: '4:20pm' },
  { value: '4:25pm', label: '4:25pm' },
  { value: '4:30pm', label: '4:30pm' },
  { value: '4:35pm', label: '4:35pm' },
  { value: '4:40pm', label: '4:40pm' },
  { value: '4:45pm', label: '4:45pm' },
  { value: '4:50pm', label: '4:50pm' },
  { value: '4:55pm', label: '4:55pm' },
  { value: '5pm', label: '5pm' },
  { value: '5:05pm', label: '5:05pm' },
  { value: '5:10pm', label: '5:10pm' },
  { value: '5:15pm', label: '5:15pm' },
  { value: '5:20pm', label: '5:20pm' },
  { value: '5:25pm', label: '5:25pm' },
  { value: '5:30pm', label: '5:30pm' },
  { value: '5:35pm', label: '5:35pm' },
  { value: '5:40pm', label: '5:40pm' },
  { value: '5:45pm', label: '5:45pm' },
  { value: '5:50pm', label: '5:50pm' },
  { value: '5:55pm', label: '5:55pm' },
  { value: '6pm', label: '6pm' },
  { value: '6:05pm', label: '6:05pm' },
  { value: '6:10pm', label: '6:10pm' },
  { value: '6:15pm', label: '6:15pm' },
  { value: '6:20pm', label: '6:20pm' },
  { value: '6:25pm', label: '6:25pm' },
  { value: '6:30pm', label: '6:30pm' },
  { value: '6:35pm', label: '6:35pm' },
  { value: '6:40pm', label: '6:40pm' },
  { value: '6:45pm', label: '6:45pm' },
  { value: '6:50pm', label: '6:50pm' },
  { value: '6:55pm', label: '6:55pm' },
  { value: '7pm', label: '7pm' },
  { value: '7:05pm', label: '7:05pm' },
  { value: '7:10pm', label: '7:10pm' },
  { value: '7:15pm', label: '7:15pm' },
  { value: '7:20pm', label: '7:20pm' },
  { value: '7:25pm', label: '7:25pm' },
  { value: '7:30pm', label: '7:30pm' },
  { value: '7:35pm', label: '7:35pm' },
  { value: '7:40pm', label: '7:40pm' },
  { value: '7:45pm', label: '7:45pm' },
  { value: '7:50pm', label: '7:50pm' },
  { value: '7:55pm', label: '7:55pm' },
  { value: '8pm', label: '8pm' },
  { value: '8:05pm', label: '8:05pm' },
  { value: '8:10pm', label: '8:10pm' },
  { value: '8:15pm', label: '8:15pm' },
  { value: '8:20pm', label: '8:20pm' },
  { value: '8:25pm', label: '8:25pm' },
  { value: '8:30pm', label: '8:30pm' },
  { value: '8:35pm', label: '8:35pm' },
  { value: '8:40pm', label: '8:40pm' },
  { value: '8:45pm', label: '8:45pm' },
  { value: '8:50pm', label: '8:50pm' },
  { value: '8:55pm', label: '8:55pm' },
  { value: '9pm', label: '9pm' },
  { value: '9:05pm', label: '9:05pm' },
  { value: '9:10pm', label: '9:10pm' },
  { value: '9:15pm', label: '9:15pm' },
  { value: '9:20pm', label: '9:20pm' },
  { value: '9:25pm', label: '9:25pm' },
  { value: '9:30pm', label: '9:30pm' },
  { value: '9:35pm', label: '9:35pm' },
  { value: '9:40pm', label: '9:40pm' },
  { value: '9:45pm', label: '9:45pm' },
  { value: '9:50pm', label: '9:50pm' },
  { value: '9:55pm', label: '9:55pm' },
  { value: '10pm', label: '10pm' },
  { value: '10:05pm', label: '10:05pm' },
  { value: '10:10pm', label: '10:10pm' },
  { value: '10:15pm', label: '10:15pm' },
  { value: '10:20pm', label: '10:20pm' },
  { value: '10:25pm', label: '10:25pm' },
  { value: '10:30pm', label: '10:30pm' },
  { value: '10:35pm', label: '10:35pm' },
  { value: '10:40pm', label: '10:40pm' },
  { value: '10:45pm', label: '10:45pm' },
  { value: '10:50pm', label: '10:50pm' },
  { value: '10:55pm', label: '10:55pm' },
];
